import { Component, Input, OnInit } from '@angular/core';
import { IPivot } from 'modelos/src';

declare const google: any;

@Component({
  selector: 'app-pivot',
  templateUrl: './pivot.component.html',
  styleUrls: ['./pivot.component.scss'],
})
export class PivotComponent implements OnInit {
  @Input() pivots: IPivot[] = [];
  @Input() pivotSeleccionadoId?: string;
  @Input() mostrarLineaCentroGps: boolean = true;

  pivotIconSize: any;
  gpsIconSize: any;
  puntosIconSize: any;

  modalAbierto = false;
  pivotModal?: IPivot;

  // test pivot para mostrar en el mapa
  centro = { lat: -25.189410302313572, lng: -63.872056878770564 };
  radio = 675.7798757254419;
  angulo = 0; // este

  gps = this.puntoEnCircunferencia(this.centro, this.radio, this.angulo);

  private puntoEnCircunferencia(
    centro: { lat: number; lng: number },
    radio: number, // en metros
    angulo: number, // en grados, 0 = este, 90 = norte
    numeroPunto?: string, // opcional, para identificar el punto
    desc?: string,
  ) {
    const R = 6378137; // Radio de la Tierra en metros
    const anguloRad = (angulo * Math.PI) / 180;

    const lat1 = (centro.lat * Math.PI) / 180;
    const lng1 = (centro.lng * Math.PI) / 180;

    const lat2 = Math.asin(
      Math.sin(lat1) * Math.cos(radio / R) +
        Math.cos(lat1) * Math.sin(radio / R) * Math.cos(anguloRad),
    );
    const lng2 =
      lng1 +
      Math.atan2(
        Math.sin(anguloRad) * Math.sin(radio / R) * Math.cos(lat1),
        Math.cos(radio / R) - Math.sin(lat1) * Math.sin(lat2),
      );

    return {
      lat: (lat2 * 180) / Math.PI,
      lng: (lng2 * 180) / Math.PI,
      numero: numeroPunto, // opcional, para identificar el punto
      desc: desc, // opcional, descripción del punto
    };
  }
  // termina test pivot

  abrirModal(pivot: IPivot) {
    this.pivotModal = pivot;
    this.modalAbierto = true;
  }

  cerrarModal() {
    this.modalAbierto = false;
    this.pivotModal = undefined;
  }

  getPivotIcon(pivot: IPivot) {
    if (!this.pivotSeleccionadoId) {
      // Si no hay pivot seleccionado, mostrar el ícono gris
      return {
        url: 'assets/svg/pivot/gray.svg',
        scaledSize: this.pivotIconSize,
      };
    }
    // Si NO es el pivot seleccionado, mostrar el ícono gris
    if (pivot._id !== this.pivotSeleccionadoId) {
      return {
        url: 'assets/svg/pivot/gray.svg',
        scaledSize: this.pivotIconSize,
      };
    }
    // Si es el seleccionado, mostrar el ícono según el estado
    let url = 'assets/svg/pivot/active.svg';
    if (pivot.ultimoEstado === 'inactivo') {
      url = 'assets/svg/pivot/inactive.svg';
    } else if (pivot.ultimoEstado === 'mantenimiento') {
      url = 'assets/svg/pivot/maintenance.svg';
    }
    return {
      url,
      scaledSize: this.pivotIconSize,
    };
  }

  getGpsIcon(pivot: IPivot) {
    if (!this.pivotSeleccionadoId) {
      // Si no hay pivot seleccionado, mostrar el ícono gris
      return {
        url: 'assets/svg/pivot/gps-gray.svg',
        scaledSize: this.gpsIconSize,
      };
    }
    // Si NO es el pivot seleccionado, mostrar el ícono gris
    if (pivot._id !== this.pivotSeleccionadoId) {
      return {
        url: 'assets/svg/pivot/gps-gray.svg',
        scaledSize: this.gpsIconSize,
      };
    }
    return {
      url: 'assets/svg/pivot/gps.svg',
      scaledSize: this.gpsIconSize,
    };
  }

  getPuntosIcon(numero?: string, pivot?: IPivot) {
    const num = numero || 'default';
    if (pivot && pivot._id !== this.pivotSeleccionadoId) {
      return {
        url: `assets/svg/pivot/gps-gray.svg`,
        scaledSize: this.puntosIconSize,
      };
    }
    // Si está seleccionado, usa el SVG normal
    return {
      url: `assets/svg/pivot/${num}.svg`,
      scaledSize: this.puntosIconSize,
    };
  }

  ngOnInit() {
    this.pivotIconSize =
      typeof google !== 'undefined' && google.maps
        ? new google.maps.Size(25, 34)
        : { width: 25, height: 34 };
    this.gpsIconSize =
      typeof google !== 'undefined' && google.maps
        ? new google.maps.Size(20, 27)
        : { width: 20, height: 27 };
    this.puntosIconSize =
      typeof google !== 'undefined' && google.maps
        ? new google.maps.Size(15, 21)
        : { width: 15, height: 21 };
  }

  getGpsMarker(pivot: IPivot) {
    // Si hay GPS, usa el último punto
    if (pivot.dispositivoGps && pivot.dispositivoGps.length > 0) {
      return pivot.dispositivoGps[pivot.dispositivoGps.length - 1];
    }
    return {
      lat: 0,
      lng: 0,
    };
  }
}
